// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"418761e9","239":"d247834a","732":"a48eb864"}[chunkId] + ".chunk.js";
};